import { useState } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import useDecks from '../../hooks/use-decks';
import MemoryButton from '../memory-button';
import { useNavigate } from 'react-router-dom';
import ModalStartReview from '../modal-start-review';
import ModalCreateDeck from '../modal-create-deck';
import MemoryCard from '../card';
import useEssayWriteDebounce from '../../../../core/hooks/useEssayWriteDebounce';
import SearchInput from '../search-input';
import useDecksAvailable from '../../hooks/use-decks-available';
import BrainLoadingWrapper from '../../../../core/components/molecules/BrainLoading';

export default function ReviewDeckCard() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');

  const {
    decksAvailable: decksAvailableResponse,
    isLoadingDecksAvailable,
    fetchAvailableFlashcards,
  } = useDecksAvailable();
  const decksAvailable = decksAvailableResponse.decks;

  const searchDebounced = useEssayWriteDebounce(search, 500);

  const filteredDecks = decksAvailable.filter((deck) =>
    deck.title.toLowerCase().includes(searchDebounced.toLowerCase())
  );

  if (isLoadingDecksAvailable) {
    return (
      <div className='flex h-[500px] w-full items-center justify-center '>
        <BrainLoadingWrapper customMessage='Carregando decks...' />
      </div>
    );
  }

  return (
    <div className='flex w-full flex-col items-center gap-2'>
      <div className='flex  h-[45px] w-full flex-row items-center justify-between gap-2'>
        <Typography className='text-h5 font-bold !text-mono-color-darker'>
          Decks
        </Typography>
        <div className='w-[171px]'>
          <SearchInput
            search={search}
            setSearch={setSearch}
            placeholder='Procure seus Decks...'
          />
        </div>
      </div>
      <MemoryCard className='flex w-full flex-col items-center p-4'>
        <div className='rounded-2xl flex w-full flex-col '>
          {/* Cabeçalho */}
          <div className='overflow-hidden pb-1'>
            <table
              className='w-full table-fixed text-left'
              style={{ borderCollapse: 'collapse', border: 'none' }}
            >
              <colgroup>
                <col className='w-auto' />
                <col className='w-20' />
                <col className='w-20' />
              </colgroup>
              <thead>
                <tr
                  style={{ border: 'none' }}
                  className='font-semibold text-mono-color-darkest'
                >
                  <th style={{ border: 'none' }}></th>
                  <th style={{ border: 'none' }} className='pr-2 text-right'>
                    Revisar
                  </th>
                  <th style={{ border: 'none' }} className='pr-2 text-right'>
                    Novo
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          {decksAvailable.length > 0 && (
            <hr className='border-mono-color-medium' />
          )}

          {/* Corpo com scroll se > 7 itens */}
          <div className='scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent mb-4 mt-2 max-h-[300px] flex-1 overflow-y-auto'>
            <table
              className='w-full table-fixed text-left'
              style={{ borderCollapse: 'collapse', border: 'none' }}
            >
              <colgroup>
                <col className='w-auto' />
                <col className='w-20' />
                <col className='w-20' />
              </colgroup>
              {decksAvailable.length > 0 ? (
                <tbody>
                  {filteredDecks.length === 0 && (
                    <div className='flex h-[300px] w-full items-center justify-center'>
                      <Typography className='text-h5 font-bold !text-mono-color-dark'>
                        Nenhum deck encontrado
                      </Typography>
                    </div>
                  )}

                  {(filteredDecks || []).map((s, i) => (
                    <tr
                      key={i}
                      style={{ border: 'none' }}
                      className='group cursor-pointer rounded-lg transition hover:bg-color-brand-primary dark:hover:bg-card-color-default'
                      onClick={() => navigate(`/memory/deck/${s.deckUuid}`)}
                    >
                      <td
                        style={{ border: 'none' }}
                        className='py-2 pl-2 font-bold text-mono-color-darkest group-hover:text-[#FFF] dark:group-hover:text-button-color-primary-negative'
                      >
                        {s.title}
                      </td>
                      <td
                        style={{ border: 'none' }}
                        className='py-2 pr-2 text-right text-mono-color-darkest group-hover:text-[#FFF] dark:group-hover:text-button-color-primary-negative'
                      >
                        {s.totalReviewNow}
                      </td>
                      <td
                        style={{ border: 'none' }}
                        className='py-2 pr-2 text-right text-mono-color-darkest group-hover:text-[#FFF] dark:group-hover:text-button-color-primary-negative'
                      >
                        {s.totalFlashcardsNew}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <div className='flex h-[300px] w-full items-center justify-center'>
                  <Typography className='text-h5 font-bold !text-mono-color-dark'>
                    Aqui é onde ficam seus decks. Crie um novo para começar a
                    organizar seus <i>flashcards</i>.
                  </Typography>
                </div>
              )}
            </table>
          </div>
        </div>
        {decksAvailable.length > 0 && (
          <hr className='w-full border-mono-color-medium pb-4' />
        )}
        <div className='flex w-full flex-col gap-2'>
          <ModalStartReview
            decks={decksAvailable.filter(
              (deck) => deck.totalFlashcardsNew > 0 || deck.totalReviewNow > 0
            )}
          />
          <MemoryButton
            label='Criar Decks'
            variant='outline'
            className='w-full'
            onClick={() => setIsOpen(true)}
          />
        </div>
        <ModalCreateDeck
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onCallbackSuccess={() => fetchAvailableFlashcards()}
        />
      </MemoryCard>
    </div>
  );
}
